<template>
  <v-form ref="p2Form" v-model="p2Form" lazy-validation>
    <v-container>
      <v-card class="UserGridlist" flat>
        <v-card-text>
          <v-row>
            <v-col>
              <v-form
                ref="tableForm"
                v-model="tableForm"
                lazy-validation
                @submit.prevent
              >
                <ryou-table
                  ref="ryouTable"
                  :rowKey="rowKey"
                  :headers="headers"
                  :queryParams="queryParam"
                  :url="url"
                  :businessKey="businessKey"
                  :dummy="false"
                  :needSearch="true"
                  :height="height"
                  :showSelect="false"
                >
                  <v-row slot="filterContainer">
                    <v-col cols="1"></v-col>
                    <v-col cols="6">
                      <v-row class="pa-6">
                        <ryou-input
                          v-model="idFilterValue"
                          :value="idFilterValue"
                          :label="'ユーザID'"
                          @keydown.enter.prevent
                        >
                        </ryou-input>
                        <v-col cols="1"></v-col>
                        <v-col cols="4">
                          <v-row class="pr-10">
                            <ryou-input
                              v-model="roomFilterValue"
                              :value="roomFilterValue"
                              :label="'部屋番号'"
                              :maxlength="10"
                              @keydown.enter.prevent
                            >
                            </ryou-input>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="3" class="UserAddBtn">
                      <ryou-blue-btn
                        :label="'新規追加'"
                        :handlerClick="handleUserAdd"
                      >
                      </ryou-blue-btn>
                    </v-col>
                  </v-row>
                </ryou-table>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-row class="fileAndBtn" v-show="showbtn">
        <v-col :cols="2">
          <v-file-input
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            label="利用者一括登録ファイル"
            v-model="chosenFile"
            :rules="inputRulesFile"
            truncate-length="55"
          >
          </v-file-input>
        </v-col>
        <v-col cols="2" style="padding-top: 25px">
          <ryou-black-btn
            :label="'ファイル入力'"
            :handlerClick="importFile"
            :iconCls="'mdi-file-upload'"
          >
          </ryou-black-btn>
        </v-col>

        <v-spacer></v-spacer>
      </v-row>
      <DormitoryUserDetailDialog
        ref="modalDialog"
        @closeDialog="closeDialog"
        :loadFlag="isload"
      >
      </DormitoryUserDetailDialog>
      <BulkRegistrationErrorDialog ref="errorDialog">
      </BulkRegistrationErrorDialog>
      <ReregistrationUserDialog
        ref="reregistrationDialog"
        :loadTableDataFunc="callLoadData"
      ></ReregistrationUserDialog>
    </v-container>
  </v-form>
</template>

<script>
import RyouInput from "@/components/formInput/RyouInput.vue";
import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
import RyouTable from "@/components/table/RyouTable.vue";
import { RyouTableMixins } from "@/mixins/RyouTableMixins";
import DormitoryUserDetailDialog from "./modules/DormitoryUserDetailDialog.vue";
import BulkRegistrationErrorDialog from "./modules/BulkRegistrationErrorDialog.vue";
import ReregistrationUserDialog from "./modules/ReregistrationUserDialog.vue";
import fileDownload from "js-file-download";

import { postUploadRequest } from "@/utils/api";
//import { getRequest } from "@/utils/api";
import { putRequest } from "@/utils/api";

export default {
  name: "DormitoryUserList",
  mixins: [RyouTableMixins],
  components: {
    RyouInput,
    RyouBlueBtn,
    RyouBlackBtn,
    DormitoryUserDetailDialog,
    RyouTable,
    BulkRegistrationErrorDialog,
    ReregistrationUserDialog,
  },
  mounted() {
    this.inputRulesFile.push(this.GlobalRules.required);
    this.$refs.ryouTable.$on("doHandleBtn", this.updateDeleBtn);
    this.$refs.ryouTable.$on("doLinkEdit", this.linkEdit);
    this.$refs.ryouTable.$on("getSelectedRowKeys", this.getSelectedRowKeys);
  },
  data() {
    return {
      p2Form: true,
      inputRulesFile: [],
      valid: true,
      search: "",
      rowKey: "rowIndex",
      businessKey: "user_id",
      tableForm: true,
      idFilterValue: "",
      roomFilterValue: "",
      chosenFile: null,
      height: 630,
      isload: false,
      headers: [
        {
          text: "仮削除",
          value: "sakujoBtn",
          type: "btn",
          width: "6%",
          sortable: false,
          groupable: false,
        },
        {
          text: "利用者区分",
          value: "user_class_name",
          width: "10%",
          sortable: true,
          groupable: false,
        },
        {
          text: "ユーザID",
          value: "user_id",
          width: "10%",
          sortable: true,
          groupable: false,
          filter: this.idFilter,
        },
        {
          text: "ユーザ名",
          value: "user_name",
          type: "link",
          width: "7%",
          sortable: false,
          groupable: false,
        },
        {
          text: "職務名称",
          value: "job_title",
          width: "9%",
          sortable: true,
          groupable: false,
        },
        {
          text: "所属",
          value: "affiliation",
          width: "6%",
          sortable: true,
          groupable: false,
        },
        {
          text: "物件名",
          value: "building_name",
          width: "8%",
          sortable: true,
          groupable: false,
        },
        {
          text: "部屋番号",
          value: "room_id",
          width: "9%",
          sortable: true,
          groupable: false,
          filter: this.roomFilter,
        },
        {
          text: "寮生区分",
          value: "dormitory_student_name",
          width: "9%",
          sortable: true,
          groupable: false,
        },
        {
          text: "入寮日",
          value: "in_dormitory_date",
          width: "7%",
          sortable: true,
          groupable: false,
        },
        {
          text: "退寮日",
          value: "out_dormitory_date",
          width: "10%",
          sortable: true,
          groupable: false,
        },
        {
          text: "備考",
          value: "remark",
          width: "12%",
          sortable: true,
          groupable: false,
        },
      ],
      url: {
        originlist: "/dormitoryUser/dormitoryListGet/",
        update: "/dormitoryUser/statusUpdate",
        fileInsert: "/dormitoryUser/fileInsertUpdate?loginUserId=",
      },
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      var that = this;
      if (
        this.$route.params.user_id != null &&
        this.$route.params.user_id != ""
      ) {
        that.url.list =
          that.url.originlist +
          this.$route.params.user_id +
          "/" +
          0 +
          "/" +
          "999";
      } else {
        if (that.$store.getters.getUserClass == "1") {
          that.url.list = that.url.originlist + " " + "/" + 0 + "/" + "999";
        } else {
          that.url.list =
            that.url.originlist +
            that.$store.getters.getUserId +
            "/" +
            0 +
            "/" +
            that.$store.getters.getUserClass;
        }
      }
    },
    //-->新規
    handleUserAdd() {
      this.isload = false;
      this.$refs.modalDialog.add();
    },
    callLoadData() {
      this.$refs.ryouTable.loadData();
    },
    //仮削除
    updateDeleBtn(item) {
      if (item.sakujoBtn == "4") {
        this.$refs.reregistrationDialog.open(item);
      } else {
        let params = {
          loginUserId: this.$store.getters.getUserId,
          user_id: item.user_id,
          user_class: item.user_class,
          out_dormitory_date: item.out_dormitory_date,
          status: item.sakujoBtn,
        };
        this.putRequest(
          this.url.update,
          params,
          this.$store.getters.getUserToken
        ).then((resp) => {
          if (resp.success) {
            this.$refs.ryouTable.loadData();
          }
        });
        setTimeout(() => {
          return;
        }, 100);
      }
    },
    //ユーザ名-->修正
    linkEdit(item) {
      this.isload = false;
      this.$refs.modalDialog.edit(item);
    },
    closeDialog() {
      this.$refs.ryouTable.loadData();
    },
    //一括登録
    importFile() {
      var valid = this.$refs.p2Form.validate();
      if (valid) {
        let formData = new FormData();
        formData.append("file", this.chosenFile);
        var fileUrl =
          this.url.fileInsert +
          this.$store.getters.getUserId +
          "&userClass=" +
          this.$store.getters.getUserClass;
        postUploadRequest(
          fileUrl,
          formData,
          this.$store.getters.getUserToken
        ).then(async (resp) => {
          if (resp.success) {
            //cognito有効の場合以下の処理を行う
            if (this.$getUseCognito()) {
              await this.registireCognitoUser(resp.result);
            }

            this.$refs.ryouTable.loadData();
          }
        });
      }
      setTimeout(() => {}, 100);
    },
    downloadCSV() {
      //参考：SalaryDeductionInformation.vue []
      //CSV作成
      this.postRequest(
        "/dormitoryUser/userCardCSVCreate",
        this.selectionRows,
        this.$store.getters.getUserToken
      ).then((resp) => {
        //ファイルパスは戻り
        if (resp.success) {
          let streamParams = {
            filePath: resp.result,
          };

          //CSVはダウンロード
          this.getStreamRequest(
            "/dormitoryUser/userCardCSVGet",
            streamParams,
            this.$store.getters.getUserToken
          )
            .then((res) => {
              const blob = new Blob([res], {
                type: "application/octet-stream;charset=utf-8",
              });
              return fileDownload(
                blob,
                "入退連携取込用データ_" + this.getDateTime() + ".csv"
              );
            })
            .catch(function (error) {
              // console.log(error);
            });
        }
      });
    },
    getDateTime() {
      const year = new Date().getFullYear();
      const month =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      const date =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate();
      const hh =
        new Date().getHours() < 10
          ? "0" + new Date().getHours()
          : new Date().getHours();
      const mm =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      const ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      const nowTime = year + month + date + hh + mm + ss;
      return nowTime;
    },
    //検索
    idFilter(value) {
      if (!this.idFilterValue) {
        return true;
      }
      return value.toLowerCase().includes(this.idFilterValue.toLowerCase());
    },

    roomFilter(value) {
      if (!this.roomFilterValue) {
        return true;
      }
      if (value != null && value != "") {
        return value.toLowerCase().includes(this.roomFilterValue.toLowerCase());
      }
    },

    //利用者一括登録cognito処理
    async registireCognitoUser(list) {
      var failureList = [];
      for (var idx in list) {
        //メールアドレス更新
        if (list[idx].updFlg) {
          await this.$cognito
            .signUp(list[idx].user_id, list[idx].mail_address, 2, null)
            .catch(() => {
              //cognito失敗ユーザをリストに格納
              failureList.push(list[idx].user_id);
            });
        }
        //新規登録
        if (list[idx].registreFlg) {
          await this.$cognito
            .signUp(
              list[idx].user_id,
              list[idx].mail_address,
              1,
              list[idx].password
            )
            .then(async () => {
              //総務（管理人）の場合は管理者グループを設定する
              await this.$cognito
                .changeGroup(list[idx].user_id, list[idx].user_class, 0)
                .catch(() => {});
            })
            .catch(() => {
              //eslint-disable-line
              //cognito失敗ユーザをリストに格納
              failureList.push(list[idx].user_id);
            });
        }
      }
      //cognitoの更新・登録に失敗したユーザが存在する場合はエラー分を表示
      await this.rollbackUserJohos(failureList);
    },
    //cognito登録・更新失敗時メッセージ表示
    async rollbackUserJohos(failureList) {
      if (failureList.length > 0) {
        //cognito失敗ユーザが存在するなら、エラーダイアログを表示

        var params = {
          userList: failureList,
        };
        await putRequest(
          "dormitoryUser/userJohoDelete",
          params,
          this.$store.getters.getUserToken
        ).then((resp) => {
          if (resp.success) {
            this.$emit("ok");
            this.$refs.tableForm.loadData();
          }
        });

        var message = "【AWS】以下のユーザ登録・更新に失敗しました。\n\n";
        var i;
        for (i = 0; i < failureList.length; i++) {
          message += failureList[i] + "\n";
        }
        this.$refs.errorDialog.open(
          "システム管理者にお問い合わせください。",
          message
        );
      }
    },
  },
  computed: {
    showbtn() {
      // 2024.11.29 kouta.noborisaka 三井化学（市原工場）:管理人(ユーザクラス:2)で一括登録のボタンとファイル入力エリアを表示
      if (
        this.$store.getters.getUserClass == "1" ||
        this.$store.getters.getUserClass == "2"
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.UserGridlist {
  outline: 1px solid rgb(147, 179, 204);
  padding-top: 30px;
  padding-bottom: 0px;
}

.UserAddBtn {
  padding-top: 30px;
  text-align: right;
}

.fileAndBtn {
  padding-top: 20px;
}
</style>
